import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Modal, Button } from 'react-bootstrap'
import { assignError } from '../../actions/error_management'

class ErrorAssignmentModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedError: null,
      errorData: {},
    }
  }

  assignError = (code, index, desc) => {
    const data = { error_code: code, content_type: this.props.contentType, object_id: this.props.errorObjectID }
    this.setState({
      errorData: data,
      selectedError: index,
      selectedErrorDesc: desc,
    })
  }

  sendError = () => {
    this.props.assignError(this.state.errorData)
    this.props.closeErrors()
  }

  render() {
    const { isModalDialogOpen, allErrors, filter } = this.props

    return (
      <Modal show={isModalDialogOpen} onHide={this.props.closeErrors}>
        <Modal.Header closeButton>
          <Modal.Title>Assign error to {filter}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                overflowX: 'hidden',
                overflowY: 'scroll',
                display: 'flex',
                flexDirection: 'column',
                height: 200,
                width: 200,
              }}
            >
              <div style={{ width: 210 }}>
                {allErrors
                  .filter((error) => {
                    return error.category === filter
                  })
                  .map((error, index) => (
                    <Button
                      key={index}
                      style={{ width: 200 }}
                      variant={this.state.selectedError === index ? 'danger' : 'default'}
                      onClick={() => this.assignError(error.error_code_id, index, error.error_code_description)}
                    >
                      {error.error_code_name}
                    </Button>
                  ))}
              </div>
            </div>

            <div style={{ width: 300, paddingLeft: 20, fontSize: 24 }}>{this.state.selectedErrorDesc}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {this.state.selectedError !== null && (
            <div>
              <Button onClick={this.sendError} variant={'default'}>
                Assign
              </Button>
              <Button onClick={this.props.closeErrors} variant={'default'}>
                Cancel
              </Button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  errors: state.errorManagement.errors,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      assignError,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorAssignmentModal))
